import type { LineItem } from '@/models/basket';
import type { ProductViewModel, Variant } from '@/models/products';
import mitt from 'mitt';

const emitter = mitt();

export default emitter;

export enum Events {
    LoggedOut = 'logged-out',
    // Basket
    AddProductNotification = 'add-product-notification',
    CreateBasket = 'create-basket',
    ChangeDebitor = 'change-debitor',
    NoLineItems = 'no-line-items',
    UpdateBasket = 'update-basket',
    PlaceOrder = 'place-order',
    // Menu
    ShowMenu = 'show-menu',
    HideMenu = 'hide-menu',
    ShowRail = 'show-rail',
    HideRail = 'hide-rail',
    // Notification
    AddNotification = 'add-notification',
    AddStaticNotification = 'add-static-notification',
    // Product
    OpenProductShelf = 'open-product-shelf',
    CloseProductShelf = 'close-product-shelf',
    OpenReorderShelf = 'open-reorder-shelf',
    CloseReorderShelf = 'close-reorder-shelf'
}

export interface OpenProductShelfBody {
    product: ProductViewModel;
    cartData: LineItem;
    variants?: Variant[];
}
export interface CloseProductShelfBody {
    cartData: LineItem;
}
